// import { Link } from "react-router-dom";
import "../Picture/Picture.css"
import "../Leaderboard/Leaderboard.css"

function Leaderboard() {
    return (
        <div className="leaderboard-background">
            <div className="picture">
                <h1>CleanUp Leaderboard</h1>
                <img src="https://i.gyazo.com/a89f8135c6c06bd1e46b6233547754fb.png"></img>
                <img src="https://i.gyazo.com/fd69ae5d88a472f89639c16a5b5ae6bf.png"></img>
            </div>
        </div>
    )
}

export default Leaderboard